module.exports = __webpack_public_path__ + "img/logo.e90426b2.png";